import React, { useState } from 'react';

import clsx from 'clsx';

import { CheckedIcon, InfoIcon } from 'assets/images/index';
import Tooltip from 'components/Tooltip/index';
import { maskMonetaryValue } from 'utils/stringUtils';
import { LOAN_OPTIONS_NAMES } from 'pages/Dashboard/steps/AcceptOffer/AutomatedOffers/ConfirmOfferPopup/LoanOfferInfo/loanOfferInfo.constants';
import styles from 'pages/Dashboard/steps/AcceptOffer/AutomatedOffers/ConfirmOfferPopup/LoanOfferInfo/LoanOfferInfo.module.scss';
import { LoanOfferIndicatorsText } from 'pages/Dashboard/steps/AcceptOffer/AutomatedOffers/ConfirmOfferPopup/LoanOfferInfo/loanOfferInfo.enums';
import { getTooltipTextForApr } from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.utils';
import { Lender } from 'enums/ApplicationsVariables';
import { OfferDto } from 'api/OffersApi';

interface LoanDetailsItem {
  title: string | JSX.Element;
  tooltipText: string | null;
  value: string | number | JSX.Element;
}

const getLoanDetailsItems = (loanOffer: OfferDto, cashToYou: number) => {
  const details: LoanDetailsItem[] = [
    {
      title: LoanOfferIndicatorsText.GrossLoan,
      tooltipText: `This is your net loan plus applicable fees.`,
      value: maskMonetaryValue(loanOffer.grossLoanAmount),
    },
    {
      title: LoanOfferIndicatorsText.CashToYou,
      tooltipText: null,
      value: maskMonetaryValue(cashToYou),
    },
    {
      title: LoanOfferIndicatorsText.APR,
      tooltipText: getTooltipTextForApr({
        isProsperLender: loanOffer.lender === Lender.Prosper,
        rate: loanOffer.rate,
        oneTimeFeePercentage: loanOffer.oneTimeFeePercentage,
      }),
      value: `${loanOffer.apr}%`,
    },
    {
      title: LoanOfferIndicatorsText.FixedRate,
      tooltipText: null,
      value: `${loanOffer.rate}%`,
    },
    {
      title: LoanOfferIndicatorsText.TermYears,
      tooltipText: null,
      value: loanOffer.term,
    },
    {
      title: <div className={styles.monthlyPaymentField}>{LoanOfferIndicatorsText.MonthlyPayment}</div>,
      tooltipText: null,
      value: (
        <div className={styles.monthlyPaymentField}>{maskMonetaryValue(loanOffer.monthlyPayment?.toFixed(2))}</div>
      ),
    },
  ];

  return details;
};

interface AcceptOfferWithPointOfSaleCardProps {
  loanOffer: OfferDto;
  cashToYou: number;
}

const LoanOfferInfo = ({ loanOffer, cashToYou }: AcceptOfferWithPointOfSaleCardProps) => {
  const [loanDetailsItems] = useState(getLoanDetailsItems(loanOffer, cashToYou));

  return (
    <div className={clsx(styles.card)}>
      <div className={clsx(styles.content)}>
        <div className={styles.loanInformationContainer}>
          {loanDetailsItems.map((loanDetailsItem, index) => (
            <div key={index} className={styles.loanInformationRow}>
              <div className={styles.optionTitle}>
                <div>{loanDetailsItem.title}</div>
                {loanDetailsItem.tooltipText && (
                  <Tooltip title={loanDetailsItem.tooltipText}>
                    <InfoIcon className={styles.iconInfo} />
                  </Tooltip>
                )}
              </div>
              <div className={styles.optionsValue}>{loanDetailsItem.value}</div>
            </div>
          ))}
        </div>
        <div className={styles.loanOptionsContainer}>
          {LOAN_OPTIONS_NAMES.map((optionName) => (
            <div key={optionName} className={styles.loanOptionsRow}>
              <CheckedIcon className={styles.checkedIcon} />
              <div>{optionName}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoanOfferInfo;
